import React from 'react';
import './Home.css';
import HeroSection from '../components/HeroSection';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

function Home() {
  return (
    <div>
      {/* Hero Section */}
      <HeroSection />

      <div className="home-page">
        
        {/* About Section */}
        <section className="about-section">
          <h2>Who We Are</h2>
          <p>
            At <strong>NorthHawks Technology</strong>, we are passionate about driving digital transformation and innovation. With expertise in IT consulting, cloud modernization, and AI-powered solutions, we empower businesses to thrive in the digital age. Our mission is to deliver scalable, reliable, and future-ready technologies tailored to your unique needs.
          </p>
        </section>

        {/* Services Section */}
        <section className="services-section">
          <h2>Our Services</h2>
          <p>
            We offer a comprehensive range of IT services to help businesses achieve their goals:
          </p>
          <ul>
            <li><strong>IT Consulting:</strong> Expert guidance to align your IT strategy with your business objectives.</li>
            <li><strong>Cloud Modernization:</strong> Seamless migration and optimization of cloud environments for agility and scalability.</li>
            <li><strong>GenAI Implementation:</strong> Automate workflows and enhance decision-making with AI-driven solutions.</li>
            <li><strong>Digital Transformation:</strong> Helping businesses embrace new technologies and adapt to change.</li>
            <li><strong>Application Development:</strong> Custom software solutions built with modern technologies like React, Flutter, and Node.js.</li>
          </ul>
          {/* Link to Services Page */}
          <Link to="/services" className="cta-button">Learn More About Our Services</Link>
        </section>

        {/* Solutions Section */}
        <section className="solutions-section">
          <h2>Our AI-Powered Solutions</h2>
          <p>
            Explore our innovative AI-powered solutions designed to transform the way businesses operate:
          </p>
          <ul>
            <li><strong>AI CSR (Customer Service Representative):</strong> Automate customer interactions across multiple channels, including VOIP, chat, and WhatsApp.</li>
            <li><strong>Pet Triage System Using GenAI:</strong> Enhance veterinary care with AI-driven triage recommendations based on pet medical history.</li>
            <li><strong>Self-Care AI:</strong> Empower customers with self-service tools integrated with CRM, billing, and order management systems.</li>
            <li><strong>Patient Notes AI:</strong> Simplify healthcare documentation with AI-powered assistance for patient interactions.</li>
          </ul>
          <Link to="/solutions" className="cta-button">Explore Our Solutions</Link>
        </section>

        {/* Why Choose Us Section */}
        <section className="why-choose-us">
          <h2>Why Choose NorthHawks?</h2>
          <ul>
            <li><strong>Expertise:</strong> Decades of experience in IT consulting and cutting-edge technologies.</li>
            <li><strong>Innovation:</strong> We stay ahead of the curve with AI, cloud, and automation solutions.</li>
            <li><strong>Customer-Centric:</strong> Your success is our priority. We tailor solutions to your unique needs.</li>
            <li><strong>Global Reach:</strong> Serving clients across Canada, Australia, Kuwait, Dubai, and beyond.</li>
          </ul>
        </section>

        {/* Call-to-Action Section */}
        <section className="cta-section">
          <h2>Let’s Build the Future Together</h2>
          <p>
            Partner with <strong>NorthHawks Technology</strong> to unlock the full potential of your business. Whether you’re looking to modernize your IT infrastructure, implement AI-driven solutions, or develop custom applications, we’re here to help.
          </p>
          <Link to="/contact" className="cta-button">Contact Us Today</Link>
        </section>
      </div>
      </div>
  );
}

export default Home;